// Welche Oberfläche ein angemeldetes Profil bekommt (E0 Sicherheit, 22.10.2026).
// Nur die Bequemlichkeitsebene: geschützt wird in der Datenbank (RLS, Status-Prüfung in
// is_staff/ist_hausmeister/my_*_ids, Sperre in auth.users über trg_konto_sperre).

export type Zugang =
  | 'verwaltung'   // Admin-Bereich
  | 'hausmeister'  // Hausmeister-App
  | 'gesperrt'     // status Inaktiv/Archiviert
  | 'portal'       // Mieter/Eigentümer – Portale folgen
  | 'kein_zugang'; // jede andere Rolle (z. B. dienstleister)

const VERWALTUNG = ['admin', 'super admin', 'master admin', 'team'];
const PORTAL = ['mieter', 'eigentuemer'];

interface ProfilFuerZugang {
  role?: string | null;
  status?: string | null;
}

/** Leerer Status zählt als aktiv (der Super-Admin hat heute keinen). */
export function istKontoAktiv(status: string | null | undefined): boolean {
  return (status ?? '').trim().toLowerCase() === 'aktiv' || (status ?? '').trim() === '';
}

export function zugangFuer(profil: ProfilFuerZugang): Zugang {
  if (!istKontoAktiv(profil.status)) return 'gesperrt';
  const rolle = (profil.role ?? '').trim().toLowerCase();
  if (VERWALTUNG.includes(rolle)) return 'verwaltung';
  if (rolle === 'hausmeister') return 'hausmeister';
  if (PORTAL.includes(rolle)) return 'portal';
  return 'kein_zugang';
}
